import React from 'react'
//styles
import styled, { css } from 'styled-components'
import { HTMLInputTypeAttribute } from 'react'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { fontFamily, fontSize } from '@/shahrzad-assets/shared-constants/fonts'
import { persianNumConverter } from '../shared-utils/persianNumConverter'
import PasswordInput from './PasswordInput'
import { FormItemInputProps } from 'antd/es/form/FormItemInput'
import { Input } from 'antd'

interface IInputProps {
  type: HTMLInputTypeAttribute
  value: any
  label: string
  placeholder: string
  id: string
  required: boolean
  onChange: (value: string) => any
  onKeyDown: (e: any) => void
  onBlur: () => any
  onFocus: () => any
  loginError: boolean
  error: boolean
  maxLength: number
  pattern: string
  isEnglishNumbers: boolean
  alignCenter: boolean
  errorText: string
  infoText: string
}

const CInput = ({
  errorText = 'اطلاعات به درستی وارد نشده است!',
  type,
  value,
  id,
  required,
  onChange,
  onKeyDown,
  onBlur,
  onFocus,
  loginError,
  error,
  label,
  placeholder,
  maxLength,
  pattern,
  infoText,
  isEnglishNumbers = false,
  alignCenter = false,
  ...props
}: Partial<IInputProps> & FormItemInputProps) => {
  const onnChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(persianNumConverter(e.target.value))
  }

  return (
    <InputContainer
      isEnglishNumbers={isEnglishNumbers}
      error={loginError || error}
      alignCenter={alignCenter}
    >
      {type === 'password' ? (
        <PasswordInput
          type='password'
          value={value}
          id={id}
          label={label}
          placeholder={placeholder ? placeholder : `${label} را وارد کنید`}
          onChange={onnChangeInput}
        />
      ) : (
        <>
          <label htmlFor={id} className='label'>
            {required && <span className='star'>*</span>} {label}
          </label>
          <Input
            type={type}
            id={id}
            placeholder={placeholder ? placeholder : `${label} را وارد کنید`}
            onKeyDown={onKeyDown}
            onChange={onnChangeInput}
            onBlur={onBlur}
            onFocus={onFocus}
            value={value}
            maxLength={maxLength}
            pattern={pattern}
            className='input'
            required
            {...props}
          />
        </>
      )}
      {error && <small className='error-text'>{errorText}</small>}

      {/* after refator we need to delete below line */}
      {loginError && <small className='error-text'>{errorText}</small>}
      {infoText && <small className='info-text'>{infoText}</small>}
    </InputContainer>
  )
}

export default CInput
interface IProps {
  error: boolean
}
const InputContainer = styled.div<IProps & IInputProps>`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_XXS};
  margin-bottom: ${dimens.SPACING_M};

  label {
    color: ${(props) => (props.error ? colors.RED : colors.text3)};
    font-size: ${fontSize.SMALL};
    transition: all 300ms ease-out;
    cursor: text;
    text-align: right;
  }

  .star {
    color: ${colors.RED};
  }

  .input {
    width: 100%;
    /* max-width: 20.625rem; */
    border-radius: ${dimens.BORDER_RADIUS_4};
    border: solid ${dimens.BORDER_WIDTH_THIN}
      ${(props) => (props.error ? colors.criticalStroke : colors.stroke2)};

    background-color: ${colors.bg2};
    color: ${colors.text1};
    height: ${dimens.HEIGHT_MEDIUM};
    padding: ${dimens.SPACING_M};
    text-align: ${(props) => props.alignCenter && 'center'};
    box-shadow: none;
    &:hover {
      background-color: ${(props) =>
        props.error ? colors.bg2 : colors.bg2Hover};
      border-color: ${(props) =>
        props.error ? colors.criticalStroke3 : colors.stroke3};
    }
    &:focus {
      background-color: ${colors.bg2};
      border-color: ${(props) =>
        props.error ? colors.criticalStroke3 : colors.primaryBrandStroke};

      &:hover {
        background-color: ${colors.bg2Hover};
        border-color: ${(props) =>
          props.error
            ? colors.criticalStroke3
            : colors.primaryBrandStrokeHover};
      }
    }
    &::placeholder {
      font-family: ${fontFamily.IRANSANS} !important;
    }

    ${(props) =>
      props.isEnglishNumbers &&
      css`
        font-family: ${fontFamily.ARIAL} !important;
      `}
  }

  small {
    display: block;
    font-size: ${fontSize.EXTRA_SMALL};
    color: ${colors.text3};
    text-align: right;
  }
  .error-text {
    color: ${colors.RED};
  }
`
